import { useMemo } from "react";
import { AchievementUnlocked } from "../AchievementUnlocked"

export const Achievement2Content = ({ step, earnings }) => {
  const mediaItems = useMemo(() => {
    const media = [];
    if (earnings?.items?.length) {
      let weapon = earnings.items.find(item => item.getType() === 'weapon');
      if (!weapon) {
        weapon = earnings.items[0];
      }
      media.push({
        image_url: weapon?.getImgSource(),
        className: 'media-item-fixed-height'
      })
    }
    return media;
  }, [earnings]);

  switch (step) {
    case 0:
      return <AchievementUnlocked
        title={'Achievement Unlocked'}
        earnings={earnings}
        textAfter={'EQUIP YOUR NUNCHUCKS HERE'}
        arrowSelector={`[data-tutorial-anchor="menu-button-0"]`}
      />
    case 1:
      return <AchievementUnlocked
        title={'CLICK ON SLOTS HERE TO SEE NEW ITEMS'}
        textLines={['UNLOCK NEW ITEMS IN BATTLE', 'PURCHASE NEW ITEMS IN THE SHOP']}
        arrowSelector={`[data-tutorial-anchor="inventory-slot-0"]`}
        mediaItems={mediaItems}
      />
  }
};